module.exports = __webpack_public_path__ + "img/zcdx-banner.aa37f247.png";